<template>
  <v-flex md4 sm6 xs12 v-if="isSmAndUp || visibleMobile">
    <v-card @click.native="goto(url)" v-bind:class="getClass(url)">
      <v-card-text class="pa-0">
        <v-container class="pa-0">
          <div class="layout row ma-0">
            <div class="sm4 xs3 flex white">
              <div class="layout column ma-0 pt-2 justify-center align-center">
                <v-icon size="48px" :color="color">{{icon}}</v-icon>
              </div>
            </div>
            <div class="sm8 xs9 flex text-sm-center py-6" :class="bgColor + ' ' + fontColor">
              <div class="title text-center" >{{ title }}</div>
            </div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  props: {
    icon: String,
    title: String,
    color: String,
    fontColor: String,
    bgColor: String,
    url: String,
    visibleMobile: Boolean
  },
  computed: {
    isXsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSmAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    }
  },
  methods: {
    goto: function(url) {
      this.$router.push(url);
    },
    getClass: function(url) {
      if (!!url) {
        return "cursosPointer";
      } else {
        return "";
      }
    }
  }
};
</script>
<style scoped>
.v-application .display-1 >>> {
  font-size: 18px !important;
}
.v-application .caption >>> {
  font-size: 13px !important;
}
</style>
